import { render, staticRenderFns } from "./drawerItem.vue?vue&type=template&id=23461e2e&scoped=true&"
import script from "./drawerItem.vue?vue&type=script&lang=js&"
export * from "./drawerItem.vue?vue&type=script&lang=js&"
import style0 from "./drawerItem.vue?vue&type=style&index=0&id=23461e2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23461e2e",
  null
  
)

export default component.exports